var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Services',"subtitle":`${_vm.formatText(_vm.service)}`}},[_c('template',{slot:"actions"},[_c('div',{staticClass:"is-flex is-flex-wrap align-center"},[(
            _vm.service === 'meal' &&
            (!_vm.$route.query.tab || _vm.$route.query.tab === 'menu')
          )?_c('el-button',{attrs:{"type":"plain"},on:{"click":_vm.goToLogs}},[_vm._v(" View Audit Log ")]):_vm._e()],1)])],2),_c(_vm.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }